module.exports = __webpack_public_path__ + "static/media/icon_price.c535e540.svg";